import { store } from 'FlowTaker/store'
import { Provider } from 'react-redux'
import PageContainer from 'FlowTaker/components/PageContainer'

export default function FlowTaker(params) {
  return (
    <Provider store={store}>
      {/* In preview mode we may create a broken state that's fixed by subsequent edits, so remount to try again */}
      <ErrorBoundary autoRetryDelay={params.isPreview ? 500 : null}>
        <PageContainer {...params} />
      </ErrorBoundary>
    </Provider>
  )
}

